


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyBEN0fVUt6eptPTDIu_4l_KTTrNwVUuKQo",
  authDomain: "opex-eye-care-b1a1c.firebaseapp.com",
  projectId: "opex-eye-care-b1a1c",
  storageBucket: "opex-eye-care-b1a1c.firebasestorage.app",
  messagingSenderId: "752458260237",
  appId: "1:752458260237:web:34f8a9978e9700eb035a44"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export